<div class="gc-table" role="table" [attr.aria-label]="title">
  <div class="gc-table__titlebar" role="row">
    <span>{{ title }}</span>
    <span>{{ range }}</span>
  </div>
  <!-- Kolomkoppen: kolom 1 is het lentepunt, de andere keys staan op een vaste
       hoek ervan; het wieltje toont de wijzer tussen de vaste locks. -->
  @if (head(); as h) {
    <div class="gc-head" role="row" [class.gc-head--sticky]="stickyHead()" data-test-id="gc-head">
      <span class="gc-head__cell gc-head__cell--era" role="columnheader">{{ h.era }}</span>
      <span class="gc-head__cell gc-head__cell--phase" role="columnheader">{{ h.phase }}</span>
      <span class="gc-head__cell gc-head__cell--wheel" role="columnheader" [attr.title]="h.wheelTitle">{{ h.wheel }}</span>
      <span class="gc-head__group gc-head__group--left">
        <span><span class="gc-head__equinox-label">{{ h.equinoxPoint }}</span> {{ h.equinoxSquare }}</span>
        <span class="gc-head__swatch gc-head__swatch--equinox"></span>
      </span>
      <span class="gc-head__group gc-head__group--right">
        {{ h.counterSquare }}
        <span class="gc-head__swatch gc-head__swatch--counter"></span>
      </span>
      @for (angle of h.left; track angle.label; let first = $first) {
        <span class="gc-head__cell gc-head__cell--angle" role="columnheader" [class.gc-head__cell--equinox]="first" [attr.title]="angle.title">
          <span [class.gc-equinox]="first">{{ angle.label }}</span>
        </span>
      }
      <span class="gc-head__cell gc-head__cell--cross" role="columnheader">{{ h.cross }}</span>
      @for (angle of h.right; track angle.label) {
        <span class="gc-head__cell gc-head__cell--angle" role="columnheader" [attr.title]="angle.title">{{ angle.label }}</span>
      }
      <span class="gc-head__cell gc-head__cell--cross" role="columnheader">{{ h.cross }}</span>
    </div>
  }
  @for (vm of rowVms(); track vm.row.id) {
    <div
      class="gc-row"
      role="row"
      [attr.data-block]="vm.row.blockColor"
      [class.gc-row--lock]="vm.row.kind === 'lock'"
      [class.gc-row--current]="vm.row.isCurrent"
      [class.gc-row--selected]="highlightPeriodId() != null && vm.row.periodId === highlightPeriodId()"
      [class.gc-row--selectable]="selectable()"
      [attr.tabindex]="selectable() ? 0 : null"
      [attr.title]="selectable() ? vm.row.vesselCross + ' & ' + vm.row.sphinxCross : null"
      (click)="select(vm.row.periodId)"
      (keydown.enter)="select(vm.row.periodId)"
    >
      <span class="gc-cell gc-cell--year">{{ vm.row.yearLabel }}</span>
      <span class="gc-cell gc-cell--phase">{{ vm.row.phaseLabel }}</span>
      <span class="gc-cell gc-cell--dial" [attr.title]="vm.dial.title" data-test-id="gc-dial">
        <svg class="gc-dial" [attr.viewBox]="'0 0 ' + dialSize + ' ' + dialSize" [attr.width]="dialSize" [attr.height]="dialSize" aria-hidden="true">
          <circle class="gc-dial__ring" [attr.cx]="dialCenter" [attr.cy]="dialCenter" [attr.r]="dialRingRadius"></circle>
          @for (tick of dialLockTicks; track $index) {
            <line class="gc-dial__lock" [attr.x1]="tick.x1" [attr.y1]="tick.y1" [attr.x2]="tick.x2" [attr.y2]="tick.y2"></line>
          }
          <polygon class="gc-dial__square gc-dial__square--counter" [attr.points]="vm.dial.counterSquare"></polygon>
          <polygon class="gc-dial__square gc-dial__square--equinox" [attr.points]="vm.dial.equinoxSquare"></polygon>
          <line class="gc-dial__hand" [attr.x1]="dialCenter" [attr.y1]="dialCenter" [attr.x2]="vm.dial.hand.x" [attr.y2]="vm.dial.hand.y"></line>
          <circle class="gc-dial__hub" [attr.cx]="dialCenter" [attr.cy]="dialCenter" r="1.4"></circle>
        </svg>
      </span>
      @for (gate of vm.row.leftGates; track $index; let first = $first) {
        <span class="gc-cell gc-cell--gate gc-cell--left" [attr.title]="first ? vm.equinoxTitle : null">
          @if (first) {
            <span class="gc-equinox" data-test-id="gc-equinox">{{ gate }}</span>
          } @else {
            {{ gate }}
          }
        </span>
      }
      <span class="gc-cell gc-cell--cross gc-cell--left">
        @if (vm.handoverTitle) {
          <i eIcon icon="arrow-left" family="solid" class="gc-marker" data-test-id="gc-handover" [attr.title]="vm.handoverTitle"></i>
        }
        {{ vm.row.leftCross }}
        <span class="gc-variant" [attr.title]="vm.leftVariantTitle">{{ vm.row.leftVariant }}</span>
      </span>
      @for (gate of vm.row.rightGates; track $index) {
        <span class="gc-cell gc-cell--gate gc-cell--right">{{ gate }}</span>
      }
      <span class="gc-cell gc-cell--cross gc-cell--right">
        @if (vm.turnTitle) {
          <i eIcon icon="rotate-right" family="solid" class="gc-marker" data-test-id="gc-turn" [attr.title]="vm.turnTitle"></i>
        }
        {{ vm.row.rightCross }}
        <span class="gc-variant" [attr.title]="vm.rightVariantTitle">{{ vm.row.rightVariant }}</span>
      </span>
    </div>
  }
</div>
